export const templateImgStyle = (device, url) => ({
  width: device.width ? (device.width * 70) / 100 + 'px' : '254px',
  backgroundImage: `url('${url}')`,
  backgroundSize: 'auto 140px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
})
